/**
 * Encode the provided string before it is added to html content, to prevent from error case
 * @param {String} input String need to be encoded
 * @return {String} encoded String
 */
function htmlEntitiesEncode(input) {
    return input
        .replaceAll(/&/g, '&amp;')
        .replaceAll(/</g, '&lt;')
        .replaceAll(/>/g, '&gt;')
        .replaceAll(/'/g, '&#39;')
        .replaceAll(/"/g, '&quot;');
}

export {htmlEntitiesEncode};